import { gql } from 'apollo-boost'
import { ID } from '../id.type'

export interface QuoteVariables {
  id: ID
  accessKey?: string
}

export interface QuoteDataEntryAdditionalPerson {
  firstName: string
  lastName: string
  gender: string
  birthday: string
}

export interface QuoteDataEntryAdditionalBuilding {
  name: string
  area: number
}

export interface QuoteDataEntryAdditional {
  pool?: boolean
  horses?: number
  dogs?: number
  people?: QuoteDataEntryAdditionalPerson[]
  buildings?: QuoteDataEntryAdditionalBuilding[]
}

export interface QuoteDataEntryRiskAddress {
  city?: string
  house?: string
  street?: string
  zipCode?: string
  gstnr?: string
  ez?: string
}

export interface QuoteDataEntryAddress {
  city: string
  door?: string
  house: string
  stairs?: string
  street: string
  zipCode: string

  riskAddress?: QuoteDataEntryRiskAddress
}

export interface QuoteDataEntryBuilding {
  basement?: number
  firstFloor?: number
  groundFloor: number
  mansarde?: number
  secondFloor?: number
}

export interface QuoteDataEntryPerson {
  birthday: string
  firstName: string
  gender: string
  lastName: string
  title: string
  email: string
  mobile: string
}

export interface QuoteDataEntry {
  id: ID
  gf?: string
  status: string
  created: string
  iban?: string
  riskStartDate?: string
  policyNumber?: string

  additional: QuoteDataEntryAdditional
  address: QuoteDataEntryAddress
  building: QuoteDataEntryBuilding
  person: QuoteDataEntryPerson
}

export interface QuoteData {
  quote: QuoteDataEntry
}

export const QUOTE_QUERY = gql`
  query show($id: ID!, $accessKey: String) {
    quote: getQuoteById(id: $id, accessKey: $accessKey) {
      id
      gf
      status
      created
      iban
      riskStartDate
      
      policyNumber
      
      additional {
        buildings {
          area
          name
        }
        dogs
        horses
        people {
          birthday
          firstName
          gender
          lastName
        }
        pool
      }
      address {
        city
        door
        house
        stairs
        street
        zipCode
        
        riskAddress {
          city
          house
          street
          zipCode
          gstnr
          ez
        }
      }
      building {
        basement
        firstFloor
        groundFloor
        mansarde
        secondFloor
      }
      person {
        birthday
        firstName
        gender
        lastName
        title
        email
        mobile
      }
    }
  }
`
